import React from 'react';
import { hydrateRoot } from 'react-dom/client';
import { initAlfaMetrics } from '@alfa-bank/newclick-alfa-metrics';
import { setApiPath } from '@alfa-bank/newclick-core/api';

import { alfaMetricsConfig } from '../shared/alfa-metrics-config';

import { Root } from './root';

const initApp = () => {
    const config = window.appConfig;

    setApiPath(config.apiEndpointPath);

    try {
        initAlfaMetrics({
            appId: config.appId,
            environment: config.nodeEnv,
            config: alfaMetricsConfig,
            metricsDomain: config.metricsDomain,
        });
    } catch {
        // eslint-disable-next-line no-console
        console.error('Ошибка инициализации метрики');
    }

    const container = document.getElementById('react-app');

    hydrateRoot(container!, <Root />);
};

initApp();
